import {ReactNode} from "react"
import {backgroundColorMap, ColorType} from "common/helpers/color.helper"

export interface DialogBoxProps {
    show?: boolean
    close: () => void
    children?: ReactNode
    title?: string
    color?: ColorType
}


export const DialogBox = ({show, children, close, title, color = "primary"}: DialogBoxProps) => {
    const backgroundColor = backgroundColorMap[color]
    return (
        <div className={`modal `} style={{display: show ? "block" : "none"}}>
            <div className="modal-background" onClick={close}/>
            <div className="modal-card model-modal" style={{width: 900}}>
                <header className={`modal-card-head ${backgroundColor}`}>
                    <p className="modal-card-title has-text-white">{title}</p>
                    <button className="delete" aria-label="close" onClick={() => close()}/>
                </header>
                {children}
            </div>
        </div>
    )
}

export const DialogBoxBody = ({children}: { children: ReactNode }) => {
    return (
        <section className="modal-card-body" style={{maxHeight: 650}}>
            {children}
        </section>
    )
}

export const DialogBoxFooter = ({children}: { children: ReactNode }) => {
    return (
        <footer className="modal-card-foot">
            {children}
        </footer>
    )
}